import { render, staticRenderFns } from "./ProjectCommentReply.vue?vue&type=template&id=03b45ef0"
import script from "./ProjectCommentReply.vue?vue&type=script&lang=js"
export * from "./ProjectCommentReply.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports